"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (route) => {
    /**
     * TODO add the environment here to make sure we are using the right url.
     */
    const basePath = route === "/auth" /* API_ROUTE.AUTH */ ? route : `${"/api" /* API_ROUTE.API */}${route}`;
    return (path) => basePath + (path || "");
};
